module.exports = __webpack_public_path__ + "img/MenuButton_SA.d8ed0575.png";